import React from "react";
import { FaCode, FaMobileAlt, FaPalette, FaBrain } from "react-icons/fa";

const services = [
  {
    icon: FaCode,
    title: "Faqe & Aplikacione Web",
    body: "Ndërtojmë faqe prezantimi, dyqane online dhe aplikacione web të plota — me dizajn modern, ngarkim të shpejtë dhe optimizim për motorët e kërkimit (SEO).",
    bullets: [
      "Faqe biznesi & landing page",
      "Dyqan online (e-commerce)",
      "Panel admin & dashboard",
    ],
  },
  {
    icon: FaMobileAlt,
    title: "Aplikacione Mobile iOS & Android",
    body: "Zhvillojmë aplikacione native dhe cross-platform për iPhone dhe Android — nga ideja deri te publikimi në App Store dhe Google Play.",
    bullets: [
      "Publikim në App Store & Google Play",
      "Njoftime push & funksionim offline",
      "Dizajn i personalizuar i ndërfaqes",
    ],
  },
  {
    icon: FaBrain,
    title: "Inteligjencë Artificiale (AI)",
    body: "Integrojmë AI në produktin ose biznesin tuaj — chatbot-ë inteligjentë, automatizim procesesh, analitikë e avancuar dhe zgjidhje të personalizuara me modele gjuhësore.",
    bullets: [
      "Chatbot & asistent virtual me AI",
      "Automatizim i rrjedhave të punës",
      "Analizë e të dhënave & raportim inteligjent",
    ],
  },
  {
    icon: FaPalette,
    title: "Dizajn UI/UX Profesional",
    body: "Krijojmë ndërfaqe të bukura dhe të lehta për t’u përdorur — prototipe interaktive, sisteme dizajni dhe identitet vizual që reflekton markën tuaj.",
    bullets: [
      "Prototip interaktiv (Figma)",
      "Sistemi i dizajnit & komponentëve",
      "Identitet vizual & branding",
    ],
  },
];

function Services() {
  return (
    <section className="services section-pad" id="services">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Shërbimet tona</span>
          <h2>Gjithçka që nevojitet për suksesin tuaj dixhital</h2>
          <p>
            Nga faqja e parë web deri te aplikacionet komplekse me AI — ofrojmë
            zgjidhje të plota teknologjike me çmime transparente dhe mbështetje
            pas dorëzimit.
          </p>
        </div>

        <div className="services-grid">
          {services.map(({ icon: Icon, title, body, bullets }) => (
            <article key={title} className="service-card">
              <div className="service-card-top">
                <div className="service-icon-wrap">
                  <Icon className="icon" aria-hidden="true" />
                </div>
              </div>
              <h3>{title}</h3>
              <p className="service-body">{body}</p>
              <ul className="service-bullets">
                {bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
